import Icon from "../../../../Icon";
import styled from "styled-components";

export const SearchInput = styled.input`
  // position: absolute;
  // z-index: -10;
  // top: 0;
  // right: 0;
  width: 100%;
  height: 38px;
  outline: 0;
  border: 0;
  font-size: 12px;
  background-color: white;
  border-radius: 19px;
  // border: 1px solid ${({ theme }) => theme.colors.Black};
  padding: 0px 38px 0px 10px;
  // opacity: 0;
`;

export const SearchForm = styled("form")`
  // width: 38px;
  width: 100%;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  position: relative;
  transition: all 0.15s ease-in-out;
  overflow: hidden;

  // &.open {
  //   width: 240px;
  //   cursor: pointer;

  //   ${SearchInput} {
  //     z-index: 1;
  //     width: 100%;
  //     height: 38px;
  //     opacity: 1;
  //   }
  // }
`;

export const SearchIcon = styled(Icon)``;

export const Button = styled("button")`
  position: relative;
  z-index: 10;
  padding: 0px;
  margin: 0px;
  border: 0px;
  width: 38px;
  height: 38px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: transparent;
  cursor: pointer;
`;
